/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/invitePacker.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { INVITE_PACKER } from "../graphql";
import { VApplication } from "../../../application";
import notification from "../config/notifications.config.json";
import axios from "axios";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface InvitePackerProps {
  email: string;
  firstName: string;
  lastName: string;
  invite: boolean;
  role: string;
}
export interface IInvitePackerMethods extends IPluginMethodMap {
  getInvitePacker(args: InvitePackerProps): Promise<any>;
}

export class InvitePackerService implements IAgentPlugin {
  readonly methods: IInvitePackerMethods;

  constructor() {
    this.methods = {
      getInvitePacker: this.getInvitePacker.bind(this),
    };
  }

  async getInvitePacker(args: InvitePackerProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: INVITE_PACKER,
          variables: {
            input: {
              invite: args?.invite,
              role: args?.role,
              user: {
                email: args?.email,
                firstName: args?.firstName,
                lastName: args?.lastName,
              },
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.createUser,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
